import React, { useState } from "react";

const DownloadModal = ({ onClose, onDownload, loading }) => {
  const [choice, setChoice] = useState("current");

  const handleClose = () => {
    if (loading) return; // don't let backdrop/cancel close it mid-fetch
    onClose();
  };

  return (
    <div
      onClick={handleClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <style>{`
        @keyframes dlSpin { to { transform: rotate(360deg); } }
        .dl-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: dlSpin 0.7s linear infinite;
          display: inline-block;
        }
      `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "1px solid #e5e7eb",
          padding: "1.5rem 1.75rem",
          width: 420,
          maxWidth: "90vw",
        }}
      >
        <p style={{ fontSize: 15, fontWeight: 500, margin: "0 0 4px" }}>
          Download Tenders
        </p>
        <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 1.25rem" }}>
          What would you like to export?
        </p>

        {[
          {
            value: "current",
            label: "Current tab only",
            desc: "Download only the tenders visible in this tab",
          },
          {
            value: "all",
            label: "All tenders – tab-wise sheets",
            desc: "One Excel file with each tab as a separate sheet",
          },
          {
            value: "all_single",
            label: "All tenders – single sheet",
            desc: "Every tender in one sheet, with a Stage column",
          },
        ].map(({ value, label, desc }) => (
          <label
            key={value}
            onClick={() => !loading && setChoice(value)}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              cursor: loading ? "not-allowed" : "pointer",
              padding: "12px 14px",
              marginBottom: 10,
              border: `1px solid ${choice === value ? "#93c5fd" : "#e5e7eb"}`,
              borderRadius: 8,
              background: choice === value ? "#eff6ff" : "transparent",
              opacity: loading ? 0.6 : 1,
              transition: "all 0.15s",
            }}
          >
            <input
              type="radio"
              name="dltype"
              checked={choice === value}
              onChange={() => !loading && setChoice(value)}
              disabled={loading}
              style={{ marginTop: 3, accentColor: "#2563eb" }}
            />
            <div>
              <p style={{ fontSize: 14, fontWeight: 500, margin: "0 0 3px" }}>
                {label}
              </p>
              <p style={{ fontSize: 12, color: "#6b7280", margin: 0 }}>
                {desc}
              </p>
            </div>
          </label>
        ))}

        {loading && (
          <p style={{ fontSize: 12, color: "#2563eb", margin: "4px 0 0" }}>
            Fetching tenders with your current filters…
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 12,
          }}
        >
          <button
            onClick={handleClose}
            disabled={loading}
            style={{
              fontSize: 13,
              padding: "7px 16px",
              borderRadius: 8,
              border: "1px solid #e5e7eb",
              background: "transparent",
              cursor: loading ? "not-allowed" : "pointer",
              color: "#374151",
              opacity: loading ? 0.6 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onDownload(choice)}
            disabled={loading}
            style={{
              fontSize: 13,
              padding: "7px 16px",
              borderRadius: 8,
              border: "none",
              background: "#2576bc",
              color: "#fff",
              fontWeight: 500,
              cursor: loading ? "not-allowed" : "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              opacity: loading ? 0.85 : 1,
            }}
          >
            {loading && <span className="dl-spinner" />}
            {loading ? "Preparing…" : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;